export const SET_UUID = 'SET_UUID';
export const SET_PLUGINID = 'SET_PLUGINID';
export const SET_PROJECTID = 'SET_PROJECTID';
export const SET_STORE_DISTRICTS = 'SET_STORE_DISTRICTS';
export const SET_ENCODE_PLUGINID = 'SET_ENCODE_PLUGINID';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_X_GW = 'SET_X_GW';
